import { BACKEND_URL as API } from "../apiConfig";

/**
 * Analytics Tracker
 * Automatically tracks page views and provides methods for custom events
 */


// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('analytics_session');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substr(2, 12);
    sessionStorage.setItem('analytics_session', sessionId);
  }
  return sessionId;
};

// Get visitor ID from response or localStorage
let visitorId = localStorage.getItem('analytics_visitor') || null;

// Parse UTM parameters from URL
const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign')
  };
};

/**
 * Track a page view
 */
export const trackPageView = async (userId = null) => {
  try {
    const utmParams = getUTMParams();
    
    const response = await fetch(`${API}/api/analytics/track/pageview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        page_path: window.location.pathname,
        page_title: document.title,
        referrer: document.referrer,
        session_id: getSessionId(),
        user_id: userId,
        ...utmParams
      })
    });
    
    const data = await response.json();
    if (data.visitor_id && !visitorId) {
      visitorId = data.visitor_id;
      localStorage.setItem('analytics_visitor', visitorId);
    }
    
    return data;
  } catch (error) {
    console.debug('Analytics tracking error:', error);
    return null;
  }
};

/**
 * Track a custom event
 */
export const trackEvent = async (eventName, eventData = {}, userId = null) => {
  try {
    await fetch(`${API}/api/analytics/track/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        event_name: eventName,
        event_data: eventData,
        visitor_id: visitorId,
        session_id: getSessionId(),
        user_id: userId
      })
    });
  } catch (error) {
    console.debug('Analytics event error:', error);
  }
};

// Pre-defined event trackers
export const trackAddToCart = (productId, productName, price, quantity = 1) => {
  return trackEvent('add_to_cart', { productId, productName, price, quantity });
};

export const trackPurchase = (orderId, total, items) => {
  return trackEvent('purchase', { orderId, total, items });
};

export const trackSignup = (method = 'email') => {
  return trackEvent('signup', { method });
};

export const trackCheckoutStart = (cartTotal, itemCount) => {
  return trackEvent('checkout_start', { cartTotal, itemCount });
};

export const trackSearch = (query, resultCount) => {
  return trackEvent('search', { query, resultCount });
};

export const trackProductView = (productId, productName) => {
  return trackEvent('product_view', { productId, productName });
};

export default {
  trackPageView,
  trackEvent,
  trackAddToCart,
  trackPurchase,
  trackSignup,
  trackCheckoutStart,
  trackSearch,
  trackProductView
};
